module.exports = __webpack_public_path__ + "img/Holt_Michael2020-06-19.e28d5c95.png";